export default __webpack_public_path__ + "static/media/photosDefaultLeft.f1156e7f.webp";